/* ============================================================
   eQiik — Oferta de lanzamiento: contador, ventana emergente y
   barra fija. Vanilla, sin librerías, y sin bloquear el render.
   ============================================================ */
(function () {
  'use strict';

  var CLAVE_POPUP = 'eqPopupVisto';
  var CLAVE_BARRA = 'eqBarraOculta';

  function guarda(clave, dias) {
    try {
      localStorage.setItem(clave, String(Date.now() + dias * 86400000));
    } catch (e) {}
  }
  function vigente(clave) {
    try {
      var v = localStorage.getItem(clave);
      return !!v && Date.now() < parseInt(v, 10);
    } catch (e) { return false; }
  }

  /* ---- Contador(es) ---- */
  function initContadores() {
    var relojes = [].slice.call(document.querySelectorAll('[data-eq-countdown]'));
    if (!relojes.length) return;

    // La fecha llega como milisegundos (data-deadline-ts); se mantiene el
    // formato antiguo (data-deadline) por si quedara algún contador viejo.
    var fin = parseInt(relojes[0].getAttribute('data-deadline-ts'), 10);
    if (isNaN(fin)) fin = new Date(relojes[0].getAttribute('data-deadline')).getTime();
    // Renovación automática: bloque de prórroga en ms (0 = no renovar)
    var renovMs = parseInt(relojes[0].getAttribute('data-renueva-ms'), 10) || 0;
    // Si la fecha no se entiende, ocultamos los contadores en vez de enseñar NaN
    if (isNaN(fin)) {
      relojes.forEach(function (r) { r.style.display = 'none'; });
      return;
    }

    function dosDigitos(n) { return n < 10 ? '0' + n : String(n); }

    function pinta() {
      var resto = fin - Date.now();
      if (resto <= 0) { termina(); return; }
      var d = Math.floor(resto / 86400000);
      var h = Math.floor((resto % 86400000) / 3600000);
      var m = Math.floor((resto % 3600000) / 60000);
      var s = Math.floor((resto % 60000) / 1000);
      relojes.forEach(function (r) {
        var ed = r.querySelector('[data-eq-d]'), eh = r.querySelector('[data-eq-h]');
        var em = r.querySelector('[data-eq-m]'), es = r.querySelector('[data-eq-s]');
        if (ed) ed.textContent = dosDigitos(d);
        if (eh) eh.textContent = dosDigitos(h);
        if (em) em.textContent = dosDigitos(m);
        if (es) es.textContent = dosDigitos(s);
      });
    }

    // Al llegar a cero: con renovación activa, la cuenta salta sola a la
    // siguiente ventana (la web sigue anunciando la oferta prorrogada);
    // sin renovación, se retira todo lo que anuncia la oferta.
    function termina() {
      if (renovMs > 0) {
        while (fin <= Date.now()) fin += renovMs;
        return;
      }
      clearInterval(tic);
      var popup = document.querySelector('[data-eq-popup]');
      var barra = document.querySelector('[data-eq-barra]');
      if (popup) cierraPopup(popup);
      if (barra) { barra.hidden = true; document.body.classList.remove('eq-con-barra'); }
      document.querySelectorAll('[data-eq-oferta-viva]').forEach(function (el) { el.hidden = true; });
      relojes.forEach(function (r) { r.style.display = 'none'; });
    }

    pinta();
    var tic = setInterval(pinta, 1000);
  }

  /* ---- Ventana emergente ---- */
  var ultimoFoco = null;

  function abrePopup(popup) {
    if (!popup.hidden) return;
    popup.hidden = false;
    // pequeño respiro para que el navegador pinte antes de animar
    // (con setTimeout y no con rAF: en una pestaña en segundo plano rAF
    //  no corre y la ventana se quedaría abierta pero invisible)
    setTimeout(function () { popup.classList.add('is-open'); }, 20);
    ultimoFoco = document.activeElement;
    document.body.classList.add('eq-sin-scroll');
    // Ojo: el fondo oscuro también lleva data-eq-popup-cerrar y va antes en el
    // HTML; es un div y no admite foco, así que se busca el botón de la X.
    var cerrar = popup.querySelector('button[data-eq-popup-cerrar]');
    if (cerrar) cerrar.focus();
    guarda(CLAVE_POPUP, parseInt(popup.getAttribute('data-dias'), 10) || 7);
  }

  function cierraPopup(popup) {
    popup.classList.remove('is-open');
    document.body.classList.remove('eq-sin-scroll');
    setTimeout(function () { popup.hidden = true; }, 250);
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  function initPopup() {
    var popup = document.querySelector('[data-eq-popup]');
    if (!popup) return;

    popup.querySelectorAll('[data-eq-popup-cerrar]').forEach(function (b) {
      b.addEventListener('click', function () { cierraPopup(popup); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) cierraPopup(popup);
    });
    // El foco no se escapa del diálogo mientras está abierto
    popup.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || popup.hidden) return;
      var f = popup.querySelectorAll('button, [href], input, select, textarea');
      if (!f.length) return;
      var primero = f[0], ultimo = f[f.length - 1];
      if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
    });

    // Si acaban de dejar el email, lo abrimos para confirmarlo
    if (location.search.indexOf('customer_posted=true') !== -1 && popup.querySelector('.eq-popup__ok')) {
      abrePopup(popup);
      return;
    }
    if (vigente(CLAVE_POPUP)) return;

    var abierto = false;
    function lanza() {
      if (abierto) return;
      abierto = true;
      abrePopup(popup);
      window.removeEventListener('scroll', porScroll);
    }
    var segundos = parseInt(popup.getAttribute('data-retardo'), 10);
    if (isNaN(segundos)) segundos = 4;
    var pctScroll = parseInt(popup.getAttribute('data-scroll'), 10) || 0;

    function porScroll() {
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      if (alto <= 0) return;
      if ((window.scrollY / alto) * 100 >= pctScroll) lanza();
    }

    setTimeout(lanza, segundos * 1000);
    if (pctScroll > 0) window.addEventListener('scroll', porScroll, { passive: true });
  }

  /* ---- Barra fija inferior ---- */
  function initBarra() {
    var barra = document.querySelector('[data-eq-barra]');
    if (!barra || vigente(CLAVE_BARRA)) return;
    barra.hidden = false;
    document.body.classList.add('eq-con-barra');

    // La barra es fija: se reserva su alto real como relleno inferior del
    // body para que nunca tape el final de la página (botones incluidos).
    function reserva() {
      if (!barra.hidden) document.body.style.paddingBottom = barra.offsetHeight + 'px';
    }
    reserva();
    window.addEventListener('resize', reserva);

    var x = barra.querySelector('[data-eq-barra-cerrar]');
    if (x) x.addEventListener('click', function () {
      barra.hidden = true;
      document.body.classList.remove('eq-con-barra');
      document.body.style.paddingBottom = '';
      window.removeEventListener('resize', reserva);
      guarda(CLAVE_BARRA, 1);
    });
  }

  function boot() {
    initContadores();
    initPopup();
    initBarra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
